import React from 'react';
interface RadioListOneColumnProps {
  options: string[];
  value: string;
  onChange: (value: string) => void;
  name: string;
}
export function RadioListOneColumn({
  options,
  value,
  onChange,
  name
}: RadioListOneColumnProps) {
  return <div className="flex flex-col gap-2" data-id="element-395">
      {options.map(option => {
      const isSelected = value === option;
      return <label key={option} className={`relative flex items-center px-4 py-3 rounded-lg border cursor-pointer transition-all ${isSelected ? 'border-[#008696] bg-[#EAF6F7] ring-1 ring-[#008696]' : 'border-[#D9D9D9] hover:border-gray-400 hover:bg-gray-50'}`} data-id="element-396">
            <input type="radio" name={name} value={option} checked={isSelected} onChange={() => onChange(option)} className="sr-only" data-id="element-397" />
            <div className={`w-4 h-4 rounded-full border flex items-center justify-center mr-3 ${isSelected ? 'border-[#008696]' : 'border-gray-300'}`} data-id="element-398">
              {isSelected && <div className="w-2 h-2 rounded-full bg-[#008696]" data-id="element-399" />}
            </div>
            <span className={`text-sm font-medium ${isSelected ? 'text-[#111111]' : 'text-[#5F5F5F]'}`} data-id="element-400">
              {option}
            </span>
          </label>;
    })}
    </div>;
}